/* @author: Augusto Monteiro */

App.Panels = App.Panels || {};
Greenmile.Panel = Greenmile.Panel || {};

Greenmile.Panel.PanelList = {
    panelOpened: {},
    open: function (id, tabConfig) {
        this.panelOpened[id] = new Greenmile.Panel.Panel(id, tabConfig);
        this.panelOpened[id].render();
        App.Panels[id] = this.panelOpened[id];
    },

    destroy: function (id) {
        this.panelOpened[id].removePanelFromUpdater();
        delete this.panelOpened[id];
        delete App.Panels[id];
    },
};
